<template>
  <!-- Circle: always visible, resizes smoothly via width/height transition. -->
  <div
    class="cursor-circle"
    :class="[`circle-size-${currentState}`, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />

  <!-- Arrow overlay: fades in on top of the circle. mix-blend-mode: difference
       on the circle inverts the page — the arrow sits above and is also inverted,
       so it reads as the original page color (same technique as Blurred). -->
  <template v-for="state in iconStates" :key="`icon-${state.name}`">
    <InlineSvg
      v-if="state.svg?.layer1"
      :src="state.svg.layer1"
      class="cursor-overlay-icon"
      :class="[{ active: currentState === state.name }, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
      :style="containerStyle"
    />
  </template>
</template>

<script>
export default { name: 'CursorArrow' };
</script>

<script setup>
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { useCursorState } from './useCursorState.js';

const { currentState, containerStyle, isOverIframe, isOutsideWindow } = useCursorState();

function getCursorSvg(state) {
  try {
    const plain = require(`../../../../../images/cursors/ARROW/${state}.svg`);
    return { layer1: plain, layer2: null };
  } catch (_) {}
  let layer1 = null, layer2 = null;
  try { layer1 = require(`../../../../../images/cursors/ARROW/${state}_1.svg`); } catch (_) {}
  try { layer2 = require(`../../../../../images/cursors/ARROW/${state}_2.svg`); } catch (_) {}
  if (layer1 || layer2) return { layer1, layer2 };
  return null;
}

const iconStates = computed(() => [
  { name: 'hover',   svg: getCursorSvg('hover') },
  { name: 'project', svg: getCursorSvg('project_hover') },
].filter(s => s.svg));
</script>

<style scoped lang="scss">
@import './cursor-shared';

// project size defined in shared
</style>
